<template>
  <div class="animation-wrapper">
    <lottie
      :options="defaultOptions"
      @animCreated="handleAnimation"
    />
  </div>
</template>

<script>
import lottie from 'vue-lottie';
import * as animationData from '@/assets/stylized-gif-animation.json'

export default {
  name: 'StylizedGifAnimation',
  components: {
    lottie
  },
  data: () => ({
    defaultOptions: {
      animationData: animationData.default,
      loop: true
    },
    animationSpeed: 1
  }),
  methods: {
    handleAnimation: function(anim) {
      anim.setSpeed(this.animationSpeed);
    }
  }
}
</script>

<style scoped lang="scss">
.animation-wrapper {
  width: 32em;
  margin-bottom: -2em;
}
</style>
